export const defaultTips = [0.20, 0.25, 0.30, 0.35];

export const tipsNorthEnd = [0.25, 0.30, 0.40, 0.50];
